import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { BaseQueryFn, FetchArgs, FetchBaseQueryError } from '@reduxjs/toolkit/query';

import {
    CreateDocumentUploadType,
    ListInvoiceUploadType,
    GetInvoiceUploadParamsType
} from '../types/invoicedocumentuploadtype';

import { ENV } from "@app/constants/env";
import { getToken } from '@app/helpers/authProvider';

const rawBaseQuery = fetchBaseQuery({
    baseUrl: ENV.DMS_APIURL,
});
const authBaseQuery: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = async (
    incomingArgs,
    api,
    extraOptions
) => {
    let args: string | FetchArgs = incomingArgs;

    // normalize string arg to object so we can set headers
    if (typeof args === 'string') {
        args = { url: args };
    }

    try {
        const token = await getToken(); // ensure this returns a non-empty string
        if (token) {
            const headers =
                (args as FetchArgs).headers instanceof Headers
                    ? (args as FetchArgs).headers
                    : new Headers((args as FetchArgs).headers);

            headers.set('Authorization', `Bearer ${token}`); // use standard casing
            (args as FetchArgs).headers = headers;
        }

        const result = await rawBaseQuery(args, api, extraOptions);

        // optional: retry once if unauthorized (adjust getToken refresh logic if available)
        if (result.error && result.error.status === 401 && token) {
            // If you have a refresh flow, invoke it here then retry.
            // const refreshed = await getRefreshedToken();
            // if (refreshed) { headers.set('Authorization', `Bearer ${refreshed}`); return rawBaseQuery(args, api, extraOptions); }
        }

        return result;
    } catch {
        return { error: { status: 500, data: 'Token retrieval failed' } } as any;
    }
};

export interface ApiResponse<T> {
    success: boolean
    message?: string
    data?: T
    error?: string
}
export const invDocUploadApi = createApi({
    reducerPath: 'invDocUploadApi',
    baseQuery: authBaseQuery,
    tagTypes: ['invDocUpload'],
    endpoints: (builder) => ({

        getInvoiceUpload: builder.query<ApiResponse<ListInvoiceUploadType[]>, { getinvoicedto: GetInvoiceUploadParamsType }>({
            query: ({ getinvoicedto }) => ({
                url: '/DocumentsUpload/InvoiceUploadRead',
                method: 'POST',

                headers: {
                    'Content-Type': 'application/json',
                },
                body: getinvoicedto,
            }),
            providesTags: ['invDocUpload'],
        }),
        createBulkDocumentUpload: builder.mutation<ApiResponse<string[]>, any[]>({
            query: (payload) => ({
                url: '/DocumentsUpload/BulkDocumentUploadCreate',
                method: 'POST',
                body: payload,   // ✅ REMOVE wrapper
                headers: {
                    'Content-Type': 'application/json',
                },
            }),
            invalidatesTags: ['invDocUpload'],
        }),        

    }),
});
export const {
    useGetInvoiceUploadQuery,
    useCreateBulkDocumentUploadMutation,
} = invDocUploadApi;